import { Component, Input } from '@angular/core';
import { Report } from '../../../../models/report.model';

@Component({
  selector: 'app-plus-ou-moins-values',
  templateUrl: './plus-ou-moins-values.component.html',
  styleUrls: ['./plus-ou-moins-values.component.scss'],
})
export class PlusOuMoinsValuesComponent {
  @Input() appraisal!: Report.Appraisal;
}
